import { cn } from '~/lib/utils';
import { useSidebarStore } from '~/lib/store/sidebar';
import { WORKSPACE_BADGE } from '~/lib/brand';
import sleedLogo from '~/assets/sleed-logo.png';

/**
 * Topbar left zone: sits over the sidebar column. Sleed logo + workspace pill.
 * The logo is a black-on-transparent wordmark; in dark theme `brightness-0 invert`
 * flips it to a clean white monochrome mark (a plain `invert` would turn the brand
 * green magenta). When the sidebar is collapsed the pill is dropped and the logo
 * shrinks so the wordmark stays legible inside the 64px rail.
 */
export function TopBarLeftZone() {
	const collapsed = useSidebarStore(s => s.collapsed);
	return (
		<div
			className={cn(
				'flex h-full items-center justify-center gap-2.5 border-r border-border-subtle bg-surface',
				collapsed ? 'px-2' : 'px-3.5'
			)}>
			<img
				src={sleedLogo}
				alt="Sleed"
				className={cn('w-auto shrink-0 object-contain dark:brightness-0 dark:invert', collapsed ? 'h-3.5' : 'h-5')}
			/>
			{!collapsed && (
				<span className="rounded-pill bg-muted px-1.5 py-0.5 text-[9.5px] font-semibold tracking-wide text-foreground-subtle uppercase">
					{WORKSPACE_BADGE}
				</span>
			)}
		</div>
	);
}
